export function hasOrderGuestDisplayInfo(
  guestName: string | undefined,
  guestEmail: string | undefined,
): boolean {
  return Boolean(guestName?.trim() || guestEmail?.trim());
}

export function getOrderGuestDisplayLabel(
  guestName: string | undefined,
  guestEmail: string | undefined,
): string | undefined {
  return guestName?.trim() || guestEmail?.trim() || undefined;
}

export function shouldShowOrderGuestRow(
  guestName: string | undefined,
  guestEmail: string | undefined,
  showGuestName: boolean,
): boolean {
  return showGuestName && hasOrderGuestDisplayInfo(guestName, guestEmail);
}
